/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MessageDetailsAliases {
  ATTACHMENTS_LIST = 'attachments-list',
  CONTEXTUAL_BAR_MESSAGE = 'contextual-bar-message',
  FETCH_ATTACHMENTS = 'fetch-attachments',
  FETCH_MESSAGE = 'fetch-message',
  FIELD_ATTACHMENTS = 'field-attachments',
  FIELD_DATE_RELEASE = 'field-date-release',
  FIELD_DESCRIPTION = 'field-description',
  FIELD_TITLE = 'field-title',
  HPMS_TEXT_HTML = 'hpms-text-html',
  MAPPER_ATTACHMENTS_LIST = 'mapper-attachments-list',
  PANEL_0 = 'panel-0',
  PANEL_1 = 'panel-1',
  TEXT_DATE_RELEASE = 'text-date-release',
  TEXT_TITLE = 'text-title',
}
export { MessageDetailsAliases };
